import { ActionReducer, createFeature, createReducer, on } from '@ngrx/store';
import { AGENT_ACTIONS_ACTIONS, AGENT_ACTIONS_API_ACTIONS } from './agent-actions.actions';
import { IReportState } from '../../../../../shared/components/report-page/report-page.component';
import { AgentActions } from '../../../../../../graphql';

export const AGENT_ACTIONS_STATE_KEY = 'agent-actions';

export interface IAgentActionsState extends IReportState<AgentActions[]> {}

export const agentActionsState: IAgentActionsState = {
  data: [],
  loading: false,
  error: null,
  totalCount: 0,
  activeViewLabel: null,
};

const reducer: ActionReducer<IAgentActionsState> = createReducer<IAgentActionsState>(
  agentActionsState,
  on(AGENT_ACTIONS_API_ACTIONS.get, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(AGENT_ACTIONS_API_ACTIONS.success, (state, { rows, totalCount }) => ({
    ...state,
    loading: false,
    data: rows,
    totalCount,
  })),
  on(AGENT_ACTIONS_API_ACTIONS.error, (state, { error }) => ({
    ...state,
    loading: false,
    totalCount: 0,
    error,
  })),
  on(AGENT_ACTIONS_ACTIONS.setActiveView, (state, { viewName }) => ({
    ...state,
    activeViewLabel: viewName,
  })),
);

export const AGENT_ACTIONS_REDUCER = createFeature({
  name: AGENT_ACTIONS_STATE_KEY,
  reducer,
});
